import React, { useEffect, useState } from "react"
import { Box, Grid, Typography } from "@mui/material"
import AppButton from "components/StyledComponents/AppButton"
import settingsIcon from "assets/icons/settings.png"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"
import styles from "./hotel.module.scss"
import CategoriesCard from "components/CategoriesCard"
import { Slider, styled } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom/cjs/react-router-dom"
import { getHotelListAction } from "redux/hotel/action"
import { hotelAction } from "redux/hotel/slice/user"

const CustomSlider = styled(Slider)(() => ({
  height: 6,
  padding: "13px 0",
  "& .MuiSlider-track": {
    border: "none",
    backgroundColor: "#A68D6D"
  },
  "& .MuiSlider-rail": {
    opacity: 1,
    backgroundColor: "#4B3C34"
  },
  "& .MuiSlider-thumb": {
    display: "none"
  }
}))

const HotelDashboard = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const visibleCount = 3
  const { hotelList } = useSelector((store) => store.hotel)
  const { isLoading } = useSelector((store) => store.app)
  const [carouselIndexMap, setCarouselIndexMap] = useState({})

  const handleNext = (hotelId, maxIndex) => {
    setCarouselIndexMap((prev) => {
      const current = prev[hotelId] || 0
      const nextIndex = current + visibleCount

      return {
        ...prev,
        [hotelId]: nextIndex > maxIndex ? 0 : nextIndex
      }
    })
  }

  const handlePrev = (hotelId, maxIndex) => {
    setCarouselIndexMap((prev) => {
      const current = prev[hotelId] || 0
      const prevIndex = current - visibleCount

      return {
        ...prev,
        [hotelId]: prevIndex < 0 ? maxIndex : prevIndex
      }
    })
  }

  useEffect(() => {
    document.title = "Hotel"
    dispatch(hotelAction.setHotelCategoryList([]))
    dispatch(getHotelListAction())
  }, [])

  return (
    <Grid container spacing={2} className="p-3">
      <Grid item xs={6}>
        <Typography variant="h2">{hotelList[0]?.parent_company_name}</Typography>
      </Grid>

      {hotelList?.length > 0 ? (
        hotelList?.map((hotel, index) => {
          /* const configurations = hotel?.hotel_configurations || [] */
          let configurations = hotel?.hotel_configurations || []
          const remainder = configurations.length % visibleCount
          if (remainder !== 0) {
            const placeholders = new Array(visibleCount - remainder).fill(null)
            configurations = [...configurations, ...placeholders]
          }

          const startIndex = carouselIndexMap[hotel.id] || 0
          const maxIndex = Math.max(0, configurations.length - visibleCount)

          const displayedCategories = configurations.slice(startIndex, startIndex + visibleCount)
          if (displayedCategories.length < visibleCount) {
            displayedCategories.push(
              ...configurations.slice(0, visibleCount - displayedCategories.length)
            )
          }

          return (
            <Grid container key={index}>
              <Grid
                item
                xs={12}
                className={`mt-4 p-4 ${styles.container} d-flex align-items-center justify-content-between`}>
                <Typography variant="h2">{hotel.name}</Typography>
                <AppButton
                  onClick={() => {
                    history.push(`/hotels/dashboard/hotel-configuration`)
                    dispatch(hotelAction.setHotelId(hotel?.id))
                  }}>
                  <img src={settingsIcon} className="me-3" alt="Settings" />
                  Hotel Configuration
                </AppButton>
              </Grid>

              <Grid
                container
                item
                xs={12}
                className={`${styles.container} mt-4 p-4 d-flex align-items-center justify-content-between`}>
                <Grid item xs={6} className="d-flex align-items-center">
                  <Typography variant="h2">Categories</Typography>
                </Grid>
                <Grid item xs={2} className="d-flex align-items-center justify-content-end">
                  <Box
                    className={styles.leftArrowButton}
                    onClick={() => handlePrev(hotel.id, maxIndex)}
                    style={{
                      cursor: "pointer",
                      opacity: 1
                    }}>
                    <ArrowBackIosIcon />
                  </Box>

                  <Box
                    className={styles.rightArrowButton}
                    onClick={() => handleNext(hotel.id, maxIndex)}
                    style={{
                      cursor: "pointer",
                      opacity: 1
                    }}>
                    <ArrowForwardIosIcon />
                  </Box>
                </Grid>

                <Grid item xs={12} className="mt-1">
                  <CategoriesCard category={displayedCategories} />
                  <Grid
                    item
                    xs={12}
                    justifyContent={"center"}
                    className="mt-4 d-flex align-items-center">
                    <CustomSlider
                      value={((startIndex + visibleCount) / configurations.length) * 100}
                      min={0}
                      max={100}
                      step={1}
                      disabled
                      sx={{ width: "10%" }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )
        })
      ) : (
        <Grid
          item
          xs={12}
          className={`mt-4 p-4 ${styles.container} d-flex align-items-center justify-content-center`}>
          <Typography variant="h2">
            {" "}
            {isLoading ? "Please wait we are fetching the hotels..." : "No Hotel Found"}
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default HotelDashboard
